declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, GridData, GridRow, AutoGenBase, AutoGenGrid } from '../../../../../../models/actor/actor';
//import { NgbFsEditGridRowModal } from '../modal/fseditgridrow';
import { NgbFsEditGridRowModal } from '../modal/fseditgridrow.modal';


@Component({
    selector: 'auto-gen-grid',
    templateUrl: './autogengrid.component.html',
    styleUrls: ['./autogengrid.component.scss']
})

export class AutoGenGridComponent implements OnInit {
    @Input() public mode;
    @Input() TemplateName: string;
    @Input() Date: Date;
    @Input() TitleName: string;

    @Input()
    public FormMode: string = 'Edit';
    @Input() public field: AutoGenGrid;//GridData;
    public fieldx: GridData;
    ngOnInit(): void {
        if (this.field) {
            var x = this.field as AutoGenGrid;
            if (x && x.Data) {
                this.fieldx = x.Data as GridData;
            }
        }
    }

    constructor(private modalService: NgbModal) {}

    Add() {
        var modelRow: GridRow = new GridRow();
        modelRow.Cells = new Array<FieldData>();
        const columns = (this.fieldx && this.fieldx.Columns && Array.isArray(this.fieldx.Columns))
            ? this.fieldx.Columns
            : (this.field && this.field.Columns && Array.isArray(this.field.Columns) ? this.field.Columns : []);

        for (let col of columns) {
            var modelCell = new FieldData();
            modelCell.DataKey = 0;
            modelCell.ValueType = col.ValueType;
            modelCell.ValueSource = col.ValueSource;
            modelCell.TemplateItemCode = col.TemplateItemCode;
            modelCell.RootCOde = col.RootCOde;
            modelCell.ParentCode = col.ParentCode;
            modelCell.HasUnit = col.HasUnit;
            modelCell.Title = col.Title;
            modelCell.Unit = col.Unit;
            modelCell.Units = col.Units;
            modelCell.Unitsdata = col.Unitsdata;
            modelCell.RowIndex = (this.field && this.field.Rows) ? this.field.Rows.length : 0;
            modelRow.Cells.push(modelCell);
        }

        if (!this.fieldx) {
            this.fieldx = new GridData();
        }
        if (!this.fieldx.Rows) {
            this.fieldx.Rows = new Array<GridRow>();
        }
        this.fieldx.Rows.push(modelRow);
     // as unknown as GridRow);

        const modalRef = this.modalService.open(NgbFsEditGridRowModal,
            {
                centered: true,
                size: "xl",                

            })
        modalRef.componentInstance.Mode = "Add";
        modalRef.componentInstance.GridRow = modelRow;
        modalRef.componentInstance.TemplateName = this.TemplateName;
        modalRef.componentInstance.Date = this.Date;
        modalRef.componentInstance.Title = this.fieldx.Title;
        modalRef.componentInstance.TitleName = this.TitleName;

        

        if (modalRef.result != null) {
            var mr = modalRef.result as unknown as string;

            if (mr == 'Close Click') {


            }
            else {
              
            }

        }

    }
    edit_row(row: GridRow) {
        // modaL OPEN
        const modalRef = this.modalService.open(NgbFsEditGridRowModal,
            {
                centered: true,
                size: "xl"

            })
        modalRef.componentInstance.Mode = "Edit";
        modalRef.componentInstance.GridRow = row;
        modalRef.componentInstance.TemplateName = this.TemplateName;
        modalRef.componentInstance.Date = this.Date;
        modalRef.componentInstance.Title = this.fieldx.Title;
        modalRef.componentInstance.TitleName = this.TitleName;


    }
}
